<template lang="pug">
  .module__main
    .module-content__container(v-loading="isLoading")
      .settings__container
        .setting__container
          .setting__title Статус работы
          .subsetting__container
            .subsetting__title BTC
            .payment-setting__value
              .token__value
                el-switch(v-model="active_btc" size="mini" @change="handleCryptoTypeActiveStatus('active_btc', 'BTC')")
          .subsetting__container
            .subsetting__title LTC
            .payment-setting__value
              .token__value
                el-switch(v-model="active_ltc" size="mini" @change="handleCryptoTypeActiveStatus('active_ltc', 'LTC')")
        .setting__container
          .setting__title Лимиты заявок
          .subsetting__container
            .subsetting__title Минимальная сумма заявки BTC
            .payment-setting__value
              .token__value
                el-input(v-model="min_fiat_amount_btc" type="number" :min="0" size="mini")
                el-button(type="primary" size="mini" @click="editPaymentsSettings('min_fiat_amount_btc')") Изменить
          .subsetting__container
            .subsetting__title Максимальная сумма заявки BTC
            .payment-setting__value
              .token__value
                el-input(v-model="max_fiat_amount_btc" type="number" :min="0" size="mini")
                el-button(type="primary" size="mini" @click="editPaymentsSettings('max_fiat_amount_btc')") Изменить
          .subsetting__container
            .subsetting__title Минимальная сумма заявки LTC
            .payment-setting__value
              .token__value
                el-input(v-model="min_fiat_amount_ltc" type="number" :min="0" size="mini")
                el-button(type="primary" size="mini" @click="editPaymentsSettings('min_fiat_amount_ltc')") Изменить
          .subsetting__container
            .subsetting__title Максимальная сумма заявки LTC
            .payment-setting__value
              .token__value
                el-input(v-model="max_fiat_amount_ltc" type="number" :min="0" size="mini")
                el-button(type="primary" size="mini" @click="editPaymentsSettings('max_fiat_amount_ltc')") Изменить
        .setting__container
          .setting__title Приоритет обработчиков
          .payment-settings__list
            .payment-setting__container.mb5(
              v-for="(setting, system) in handlers_priority"
              :key="`handler-priority-${system}`"
            )
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .handlers-priority__container
                  .handler-priority__container(v-for="(handler, index) in handlers_priority[system]" :key="`handler-priority-${system}-${handler}`")
                    .handler__name {{ handler }}
                    .handler-priority__btns
                      el-button(
                        v-if="index !== 0"
                        circle
                        size="mini"
                        icon="el-icon-top"
                        @click="changeHandlerPriority(index, index - 1, system)"
                      )
                      el-button(
                        v-if="index !== handlers_priority[system].length - 1"
                        circle
                        size="mini"
                        icon="el-icon-bottom"
                        @click="changeHandlerPriority(index, index + 1, system)"
                      )
                      el-button(
                        circle
                        size="mini"
                        icon="el-icon-delete"
                        @click="deleteHandlerPriorityFromSystem(index, system)"
                        type="danger"
                      )
                  .handler-add__container(v-if="handlersPriorityLeftSystems[system].available")
                    el-select(v-model="addingHandlersPriority[system]")
                      el-option(
                        v-for="addingHandler in handlersPriorityLeftSystems[system].list"
                        :label="addingHandler"
                        :value="addingHandler"
                        :key="`adding-handler-${system}-${addingHandler}`"
                        size="mini"
                      )
                    .handler-add__btn
                      el-button(
                        circle
                        icon="el-icon-plus"
                        size="mini"
                        :disabled="!addingHandlersPriority[system]"
                        @click="addHandlerPriorityToSystem(system)"
                        type="success"
                      )
        .setting__container
          .setting__title Лимиты платежных систем
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in payment_systems_amount" :key="`payments-amounts-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .limits__container
                  el-input(v-model="payment_systems_amount[system].min" type="number" :min="0")
                  el-input(v-model="payment_systems_amount[system].max" type="number" :min="0")
            .mt10
              el-button(
                size="mini"
                type="primary"
                @click="editPaymentsSettings('payment_systems_amount')"
              ) Обновить
        .setting__container
          .setting__title Комиссия за обработку
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in commission_percent" :key="`commission-percent-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .limits__container
                  el-input(v-model="commission_percent[system]" type="number" :min="0")
            .mt10
              el-button(
                size="mini"
                type="primary"
                @click="editPaymentsSettings('commission_percent')"
              ) Обновить
        .setting__container
          .setting__title Время жизни сделок
          .payment-settings__list
            .payment-setting__container.mb5(v-for="(setting, system) in payment_system_deal_timeout" :key="`payment-system-deal-timeout-${system}`")
              .payment-setting__title {{ paymentSystems[system] || system }}
              .payment-setting__value
                .limits__container
                  el-input(v-model="payment_system_deal_timeout[system]" type="number" :min="0")
            .mt10
              el-button(
                size="mini"
                type="primary"
                @click="editPaymentsSettings('payment_system_deal_timeout')"
              ) Обновить
        .setting__container
          .setting__title Комиссия по обороту BTC
          .subsetting__container
            .subsetting__title Проценты
            .payment-settings__list
              .payment-setting__container.mb5(v-for="(setting, system) in turnover_commission_percent_btc" :key="`turnover-commission-percent-btc-${system}`")
                .payment-setting__title {{ paymentSystems[system] || system }}
                .payment-setting__value
                  .limits__container
                    el-input(v-model="turnover_commission_percent_btc[system]" type="number" :min="0")
              .mt10
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('turnover_commission_percent_btc')"
                ) Обновить
          .subsetting__container
            .subsetting__title Адреса пополнения
            .payment-settings__list
              .payment-setting__container.mb5(v-for="(setting, system) in turnover_commission_addresses_btc" :key="`turnover-commission-addresses-btc-${system}`")
                .payment-setting__title {{ paymentSystems[system] || system }}
                .payment-setting__value
                  .limits__container
                    el-input(v-model="turnover_commission_addresses_btc[system]")
                    .warning-message(v-if="isNotValidTurnoverCommissionBtcAddresses[system]") Адрес не валиден
              .mt10
                el-button(
                  size="mini"
                  type="primary"
                  :disabled="isAnyCommissionBtcAddressIsNotValid"
                  @click="editPaymentsSettings('turnover_commission_addresses_btc')"
                ) Обновить
        .setting__container
          .setting__title Комиссия по обороту LTC
          .subsetting__container
            .subsetting__title Проценты
            .payment-settings__list
              .payment-setting__container.mb5(v-for="(setting, system) in turnover_commission_percent_ltc" :key="`turnover-commission-percent-ltc-${system}`")
                .payment-setting__title {{ paymentSystems[system] || system }}
                .payment-setting__value
                  .limits__container
                    el-input(v-model="turnover_commission_percent_ltc[system]" type="number" :min="0")
              .mt10
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('turnover_commission_percent_ltc')"
                ) Обновить
          .subsetting__container
            .subsetting__title Адреса пополнения
            .payment-settings__list
              .payment-setting__container.mb5(v-for="(setting, system) in turnover_commission_addresses_ltc" :key="`turnover-commission-addresses-ltc-${system}`")
                .payment-setting__title {{ paymentSystems[system] || system }}
                .payment-setting__value
                  .limits__container
                    el-input(v-model="turnover_commission_addresses_ltc[system]")
                    .warning-message(v-if="isNotValidTurnoverCommissionLtcAddresses[system]") Адрес не валиден
              .mt10
                el-button(
                  size="mini"
                  type="primary"
                  :disabled="isAnyCommissionLtcAddressIsNotValid"
                  @click="editPaymentsSettings('turnover_commission_addresses_ltc')"
                ) Обновить
        .setting__container
          .setting__title Токены
          .subsetting__container
            .subsetting__title Saudi
            .payment-setting__value
              .token__value
                el-input(v-model="saudi_token" size="mini")
              .payment-edit__button
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('saudi_token')"
                ) Изменить
          .subsetting__container
            .subsetting__title Emirates
            .payment-setting__value
              .token__value
                el-input(v-model="emirates_token" size="mini")
              .payment-edit__button
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('emirates_token')"
                ) Изменить
          .subsetting__container
            .subsetting__title Honey
            .payment-setting__value
              .token__title ID клиента
              .token__value
                el-input(v-model="honey_client_id" size="mini")
              .payment-edit__button
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('honey_client_id')"
                ) Изменить
            .payment-setting__value
              .token__title Секретный ключ
              .token__value
                el-input(v-model="honey_client_secret" size="mini")
              .payment-edit__button
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('honey_client_secret')"
                ) Изменить
            .payment-setting__value
              .token__title Ключ шифрования
              .token__value
                el-input(v-model="honey_client_signature" size="mini")
              .payment-edit__button
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('honey_client_signature')"
                ) Изменить
          .subsetting__container
            .subsetting__title Bridge
            .payment-setting__value
              .token__title Токен
              .token__value
                el-input(v-model="bridge_token" size="mini")
              .payment-edit__button
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('bridge_token')"
                ) Изменить
            .payment-setting__value
              .token__title Секретный ключ
              .token__value
                el-input(v-model="bridge_secret_key" size="mini")
              .payment-edit__button
                el-button(
                  size="mini"
                  type="primary"
                  @click="editPaymentsSettings('bridge_secret_key')"
                ) Изменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_SETTINGS, UPDATE_SETTING } from '@/store/const/settings';
import instruments from '@/mixins/instruments';

export default {
  name: 'Settings',
  mixins: [instruments],
  data() {
    return {
      saudi_token: '',
      emirates_token: '',
      bridge_token: '',
      bridge_secret_key: '',
      honey_client_id: '',
      honey_client_secret: '',
      honey_client_signature: '',
      handlers_priority: {
        card: [],
        sbp: [],
        sim: [],
        foreign_sbp: [],
        alfa: [],
        qr: [],
        foreign_qr: [],
      },
      payment_systems_amount: {
        card: [],
        sbp: [],
        sim: [],
        foreign_sbp: [],
        alfa: [],
        qr: [],
        foreign_qr: [],
      },
      commission_percent: {
        card: 0,
        sbp: 0,
        sim: 0,
        foreign_sbp: 0,
        alfa: 0,
        qr: 0,
        foreign_qr: 0,
      },
      payment_system_deal_timeout: {
        card: 0,
        sbp: 0,
        sim: 0,
        foreign_sbp: 0,
        alfa: 0,
        qr: 0,
        foreign_qr: 0,
      },
      addingHandlersPriority: {
        card: '',
        sbp: '',
        sim: '',
        foreign_sbp: '',
        alfa: '',
        qr: '',
        foreign_qr: '',
      },
      active_btc: false,
      active_ltc: false,
      min_fiat_amount_btc: 0,
      max_fiat_amount_btc: 1000000,
      min_fiat_amount_ltc: 0,
      max_fiat_amount_ltc: 1000000,
      turnover_commission_percent_btc: {
        card: 0,
        sbp: 0,
        sim: 0,
        foreign_sbp: 0,
        alfa: 0,
        qr: 0,
        foreign_qr: 0,
      },
      turnover_commission_addresses_btc: {
        card: '',
        sbp: '',
        sim: '',
        foreign_sbp: '',
        alfa: '',
        qr: '',
        foreign_qr: '',
      },
      turnover_commission_percent_ltc: {
        card: 0,
        sbp: 0,
        sim: 0,
        foreign_sbp: 0,
        alfa: 0,
        qr: 0,
        foreign_qr: 0,
      },
      turnover_commission_addresses_ltc: {
        card: '',
        sbp: '',
        sim: '',
        foreign_sbp: '',
        alfa: '',
        qr: '',
        foreign_qr: '',
      },
    };
  },
  async mounted() {
    await this.loadAndSetSettings();
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('settings', ['paymentSystems', 'handlers']),
    isLoading() {
      return this.loading(LOAD_SETTINGS) === 'loading';
    },
    handlersPriorityLeftSystems() {
      const result = {};
      for (const system of Object.keys(this.paymentSystems)) {
        const handlersLeft = this.handlers.filter((handler) => !this.handlers_priority[system].includes(handler));
        result[system] = { available: handlersLeft.length > 0, list: handlersLeft };
      }
      return result;
    },
    isNotValidTurnoverCommissionBtcAddresses() {
      const result = {};
      for (const paymentSystem of Object.keys(this.turnover_commission_addresses_btc)) {
        const address = this.turnover_commission_addresses_btc[paymentSystem];
        result[paymentSystem] = !(address.length === 0 || this.isValidBtcAddress(address));
      }
      return result;
    },
    isAnyCommissionBtcAddressIsNotValid() {
      return Object.values(this.isNotValidTurnoverCommissionBtcAddresses).includes(true);
    },
    isNotValidTurnoverCommissionLtcAddresses() {
      const result = {};
      for (const paymentSystem of Object.keys(this.turnover_commission_addresses_ltc)) {
        const address = this.turnover_commission_addresses_ltc[paymentSystem];
        result[paymentSystem] = !(address.length === 0 || this.isValidLtcAddress(address));
      }
      return result;
    },
    isAnyCommissionLtcAddressIsNotValid() {
      return Object.values(this.isNotValidTurnoverCommissionLtcAddresses).includes(true);
    },
  },
  methods: {
    ...mapActions('settings', {
      loadSettings: LOAD_SETTINGS,
      updateSetting: UPDATE_SETTING,
    }),
    async loadAndSetSettings() {
      const request = await this.loadSettings();
      if (request.success) {
        const settings = request.data;
        for (const settingName of Object.keys(settings)) {
          this[settingName] = settings[settingName];
          if (settingName === 'payment_systems_priority') {
            this.originalPaymentSystemPriorityString = JSON.stringify(settings[settingName]);
          }
        }
      }
    },
    async requestSettingUpdate(name, setting) {
      const request = await this.updateSetting({ name, setting });
      if (request.success) {
        this.$message.success('Настройки успешно обновлены');
        await this.loadAndSetSettings();
        return true;
      } else {
        this.$message.error(`Ошибка обновления настроек: ${request.message || 'Неизвестная ошибка'}`);
        return false;
      }
    },
    async editPaymentsSettings(settingsName) {
      return await this.requestSettingUpdate(settingsName, this[settingsName]);
    },
    async editSetting(settingsName, switchOnFail) {
      const isUpdateSuccess = await this.requestSettingUpdate(settingsName, this[settingsName]);
      if (!isUpdateSuccess && switchOnFail) {
        this[settingsName] = !this[settingsName];
      }
    },
    async changeHandlerPriority(index, newIndex, system) {
      this.swapHandlerPriority(index, newIndex, system);
      const wasChanged = await this.editPaymentsSettings('handlers_priority');
      if (!wasChanged) {
        this.swapHandlerPriority(index, newIndex, system);
      }
    },
    swapHandlerPriority(index, newIndex, system) {
      const oldValue = this.handlers_priority[system][index];
      const newPriority = [...this.handlers_priority[system]];

      newPriority[index] = newPriority[newIndex];
      newPriority[newIndex] = oldValue;

      this.handlers_priority[system] = newPriority;
    },
    async addHandlerPriorityToSystem(system) {
      if (this.handlers_priority[system].includes(this.addingHandlersPriority[system])) {
        return this.$message.warning('Указанный обработчик уже используется в приоритезации платежной системы');
      }
      this.handlers_priority[system].push(this.addingHandlersPriority[system]);
      const wasChanged = await this.editPaymentsSettings('handlers_priority');
      if (wasChanged) {
        this.addingHandlersPriority[system] = '';
      } else {
        this.handlers_priority[system].splice(this.handlers_priority[system].length - 1, 1);
      }
    },
    async deleteHandlerPriorityFromSystem(index, system) {
      this.$confirm(
        `Вы уверены, что хотите удалить обработчик ${this.handlers_priority[system][index]} из платежной системы ${system}?`,
        'Подтверждение',
      )
        .then(async () => {
          const oldPriority = [...this.handlers_priority[system]];
          this.handlers_priority[system].splice(index, 1);
          const wasChanged = await this.editPaymentsSettings('handlers_priority');
          if (!wasChanged) {
            this.handlers_priority[system] = oldPriority;
          }
        })
        .catch(() => {
          this.$message.info('Удаление отменено');
        });
    },
    async handleCryptoTypeActiveStatus(activeSetting, cryptoType) {
      this.$confirm(
        `Вы уверены, что хотите ${this[activeSetting] ? 'активировать' : 'деактивировать'} ${cryptoType}`,
        'Подтверждение',
      )
        .then(async () => {
          await this.editSetting(activeSetting, true);
        })
        .catch(() => {
          this[activeSetting] = !this[activeSetting];
          this.$message.info('Изменение отменено');
        });
    },
  },
};
</script>
<style scoped>
.settings__container {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.setting__container {
  width: 240px;
  padding: 10px;
  background-color: white;
  margin: 5px;
  border-radius: 5px;
  box-shadow: 1px 1px 1px #9f9f9f;
}

.setting__block {
  margin-bottom: 10px;
}

.setting__title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

.settings-ads-ids__add button {
  margin-left: 5px;
}

.handlers-priority__container {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}

.handler-priority__container {
  display: flex;
  padding: 4px;
  margin-bottom: 2px;
  align-items: center;
}

.handler-priority__btns {
  margin-left: 5px;
}

.handler-add__container {
  display: flex;
  align-items: center;
}

.handler-add__btn {
  width: 30px;
  height: 30px;
  margin: auto 5px;
}

.payment-setting__container {
  border: 1px solid #dcdfe6;
  padding: 4px;
}

.payment-edit__button {
  margin-top: 5px;
}

.subsetting__container {
  padding: 4px;
  border: 1px solid #dcdfe6;
  margin-bottom: 5px;
}

.subsetting__container:has(.token__title) .payment-edit__button {
  margin-bottom: 5px;
}

.subsetting__title {
  font-weight: 500;
  text-align: center;
  margin-bottom: 5px;
  font-size: 14px;
}

.token__title {
  font-size: 12px;
}

.warning-message {
  font-size: 10px;
  text-align: right;
  color: red;
}
</style>
